import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateDate',
  pure: true,
  standalone: false
})
export class TranslateDatePipe implements PipeTransform {
  transform(value: string | Date, type: string, language: string): string {
    const base: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
    const options: Intl.DateTimeFormatOptions = type === 'longDate' ? { ...base, day: 'numeric' } : base;
    return new Date(value).toLocaleDateString(language, options);
  }
}
